import React, {Component} from 'react';
var Select = require('react-select');
//import 'react-select/dist/react-select.css';

export default class TableArrayToMultiSelectFormatter extends React.Component {
    constructor(props) {
        super(props);
        console.log('props in formatter', props);
        this.updateData = this.updateData.bind(this);
        this.state = {items: props.defaultValue};
        this.onChangeOption = this.onChangeOption.bind(this);
    }

    onChangeOption(selectedOptions) {
        console.log('toggle', this.state.items);
        this.setState({items: selectedOptions});
    }

    updateData() {
        var valuesToSave = _.map(this.state.items, function (item, key) {
            return item.value;
        });
        console.log('valuesToSave', valuesToSave);
        this.props.row[this.props.itemName] = valuesToSave;
        this.props.onUpdate({'row': this.props.row, 'cellName': this.props.itemName});
    }

    render() {
        console.log('this.selectOptionsList', this.props);
        return (
            <span ref='inputRef'>
                 <button
                     className='btn btn-info btn-xs textarea-save-btn'
                     onClick={ this.updateData }>
          save
        </button>
       <Select
           tabIndex="0"
           searchable={true}
           multi
           selectedOptions
           clearable={false}
           //optionRenderer={renderOption}
           //valueRenderer={renderValue}
           placeholder="Focus areas"
           options={this.props.itemsList}
           onChange={this.onChangeOption}
           value={this.state.items}
       />

      </span>
        );
    }
}
